'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.Result = Result;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _navLink = require('../navLink');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/prop-types */
function Result(_ref) {
  var className = _ref.className,
      type = _ref.type,
      title = _ref.title,
      description = _ref.description,
      extra = _ref.extra,
      links = _ref.links,
      restProps = _objectWithoutProperties(_ref, ['className', 'type', 'title', 'description', 'extra', 'links']);

  var iconMap = {
    error: _react2.default.createElement(_icon2.default, { className: 'error', type: 'close-circle' }),
    success: _react2.default.createElement(_icon2.default, { className: 'success', type: 'check-circle' })
  };
  return _react2.default.createElement(
    'div',
    _extends({ className: 'j-com-result ' + className }, restProps),
    _react2.default.createElement(
      'div',
      { className: 'icon' },
      iconMap[type]
    ),
    _react2.default.createElement(
      'div',
      { className: 'title' },
      title
    ),
    description && _react2.default.createElement(
      'div',
      { className: 'description' },
      description
    ),
    extra && _react2.default.createElement(
      'div',
      { className: 'extra' },
      extra
    ),
    links && _react2.default.createElement(
      'div',
      { className: 'actions' },
      _react2.default.createElement(_navLink.NavLink, { links: links })
    )
  );
}


//////////////////
// WEBPACK FOOTER
// ./src/components/result/index.jsx
// module id = 95
// module chunks = 0